export const versionNames = ["fft01", "fft01unsafe", "fft47", "fft_rust"];
